import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath";
import { getCatalogPageByPath } from "@stoneage/App/Services/Catalog/CategoryService";

export const XngRequestDataFromApi: any = async (props: any) => {
    props.apiResult = await getCatalogPageByPath(props.apiParameter);
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
